"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInputState = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Simple Hook to use with input tag. The primary purpose is an abstraction over input onChange property.
 * () => {
 *   const [value, onChange] = useInputState("");
 *
 *   return <Input type="text" value={value} onChange={onChange} />;
 * }
 */
const useInputState = function () {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const [state, setState] = React.useState(initialState);
  const setInputState = React.useCallback(event => setState(event.target.value), []);
  return [state, setInputState];
};
exports.useInputState = useInputState;